// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import App from './App';
import router from './router';

/* IE Support start*/
import 'core-js/es6/number';
import 'core-js/shim';
/* IE Support End*/

import BootstrapVue from 'bootstrap-vue';
import axios from 'axios';
Vue.use(BootstrapVue);
/*import 'bootstrap/dist/css/bootstrap.css';*/
import 'bootstrap-vue/dist/bootstrap-vue.css';
import 'vue-good-table/dist/vue-good-table.css';
import VueSweetalert2 from 'vue-sweetalert2';
Vue.use(VueSweetalert2);

import linkify from 'vue-linkify';
Vue.directive('linkified', linkify);

Vue.config.productionTip = false;
Vue.prototype.isBackend1 = false;
/* eslint-disable no-new */
var vm = new Vue({
    el: '#app',
    router,
    components: {App},
    template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js